import { TApiResponse } from '@/common/types/response';

import { calculateDynamic, setRegionDashboardsLocalStorage } from '../../utils/localStorage';
import { TRegionDashboardStoreState } from './types';

export function setBaseRegionInfo(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['baseRegionInfo']>,
) {
  state.baseRegionInfo = res.data;
}

export function setRatingCards(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['ratingCards']>,
) {
  state.ratingCards = res.data;
  setRegionDashboardsLocalStorage({
    data: calculateDynamic(res.data, 'amount', 'oldAmount'),
    keyData: 'ratingCards',
  });
}

export function setRatingList(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['ratingList']>,
) {
  state.ratingList = res.data;
}

export function setIndicatorCards(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['indicatorCards']>,
) {
  state.indicatorCards = res.data;
  setRegionDashboardsLocalStorage({
    data: calculateDynamic(res.data, 'amount', 'oldAmount'),
    keyData: 'indicatorCards',
  });
}

export function setDynamicCards(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['dynamicCards']>,
) {
  state.dynamicCards = res.data;
}

export function setEventsCountByTypes(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['eventsCountByTypes']>,
) {
  state.eventsCountByTypes = res.data;
}

export function setAgreementsCountByTypes(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['agreementsCountByTypes']>,
) {
  state.agreementsCountByTypes = res.data;
}

export function setRepresentativeAbroadInfo(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['representativeAbroadInfo']>,
) {
  state.representativeAbroadInfo = res.data;
}

export function setRepresentativeAbroadInfoTable(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['representativeAbroadInfoTable']>,
) {
  state.representativeAbroadInfoTable = res.data;
}
